import { apiClient } from './baseApi';

export const proposalTemplatesService = {
  async list() {
    const response = await apiClient.get('/proposal-templates');
    return response.data?.data ?? [];
  },

  async get(id) {
    const response = await apiClient.get(`/proposal-templates/${id}`);
    return response.data?.data;
  },

  async create(payload) {
    const response = await apiClient.post('/proposal-templates', payload);
    return response.data?.data;
  },

  async update(id, payload) {
    const response = await apiClient.put(`/proposal-templates/${id}`, payload);
    return response.data?.data;
  },

  async remove(id) {
    const response = await apiClient.delete(`/proposal-templates/${id}`);
    return response.data?.data;
  },
};
